module.exports = __webpack_public_path__ + "static/blog68-f426672aee7d3a2f7b61708559929237.png";